import {
  CLEAR_FORGET_PASSWORD,
  CLEAR_FORGET_PASSWORD_SUCCESS,
  CLEAR_FORGET_PASSWORD_FAILED,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  loading: false,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_FORGET_PASSWORD:
      state = { ...state }
      break
    case CLEAR_FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
      }
      break
    case CLEAR_FORGET_PASSWORD_FAILED:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: action.payload,
      }
      break
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        loading: true,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
        forgetError: null,
        loading: false,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { 
        ...state, 
        forgetSuccessMsg: null,
        forgetError: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
